import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Navbar from './components/NavBar/NavBar';
import Contact from './pages/Contact';
import Services from './pages/Services';
import { LanguageProvider } from "./LanguageContext";


function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />

          </Routes>
        </Router>
      </LanguageProvider>
    </div>
  );
}

export default App;
